// extracted by mini-css-extract-plugin
export default {"section":"PieceSettingsBodyEmployeeOnlySection_section__Ek1Zd"};